export const currencyFormatToAny = ({
  value,
  type = 'es-MX',
  currency = false,
  style = false,
  unit = false,
  roundMax = false,
  decimalsMax = 2,
  roundMin = false,
  decimalsMin = 2,
}) => {
  let numberFormat = new Intl.NumberFormat(type, {
    style: style ? style : 'decimal',
    unit: unit ? unit : undefined,
    currency: currency ? currency : undefined,
    maximumFractionDigits: roundMax ? 0 : decimalsMax,
    minimumFractionDigits: roundMin ? 0 : decimalsMin,
  }).format(value)

  return numberFormat
}
